import React from 'react';
import { courseAds } from '../data/courseAds';
import '../styles/CourseCards.css';

const categoryColors = {
  Programming: '#059669',
  AI: '#7c3aed',
  Java: '#d97706',
  Automation: '#2563eb',
  DevOps: '#dc2626',
};

function StarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

function CourseCardsGrid() {
  return (
    <div className="course-cards-section">
      <div className="courses-grid">
        {courseAds.map((course) => (
          <a
            key={course.url}
            href={course.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`course-card ${course.udemyBusinessFree ? 'course-card--free' : ''}`}
            style={{ '--cat-color': categoryColors[course.category] || '#2563eb' }}
          >
            <div className="course-thumbnail-wrap">
              <img
                src={course.thumbnail}
                alt={`${course.title} course thumbnail`}
                className="course-thumbnail"
                loading="lazy"
              />
              <div className="course-thumbnail-overlay" />
              <div className="course-play-btn" aria-hidden="true">
                <PlayIcon />
              </div>

              {course.udemyBusinessFree && (
                <div className="course-badges">
                  <span className="course-badge course-badge--free">FREE on Udemy Business</span>
                </div>
              )}
            </div>

            <div className="course-card-body">
              <span className="course-level">{course.level}</span>
              <h3 className="course-title">{course.title}</h3>
              <p className="course-subtitle">{course.subtitle}</p>

              <div className="course-stats">
                <span className="course-stat course-stat--rating">
                  <StarIcon />
                  {course.rating}
                </span>
                <span className="course-badge course-badge--highest-rated">Highest Rated</span>
              </div>

              <div className="course-footer">
                <span className="course-footer-category">{course.category}</span>
                <span className="course-link">Learn More &gt;</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default CourseCardsGrid;
